module.exports = __webpack_public_path__ + "img/mundm.9654d8c4.png";